import { API } from 'data';
import { __MergePaginationPage } from 'scripts/paginationQuery';
import { RestAPI } from 'scripts';
import { PaginationType, PostType } from 'types';

export const __MY_VIEWS_PAGE_SIZE = 18;

export type __MyViewItemType = { id: number; post: PostType<'list'> };

export function __FetchMyViews(
    page: number,
    prev?: PaginationType<__MyViewItemType>,
): Promise<PaginationType<__MyViewItemType>> {
    return RestAPI.get<PaginationType<__MyViewItemType>>(API.posts.myViews, {
        page_size: __MY_VIEWS_PAGE_SIZE,
        ordering: '-created_at',
        page,
    }).then((res) => __MergePaginationPage(page, res.data, prev));
}
